module.exports = "pegasus_template/assets/image_library_block.png";